export const MODULE_NAME = 'clients';
export const ACCESS_NAME = 'Clients';
